export const writeTextToClipboard = (text) => window.navigator.clipboard.writeText(text)
